module.exports = __webpack_public_path__ + "img/bidtheatre.939f9c3.png";